import SimpleSelect from "../Assets/SimpleSelect/SimpleSelect"
import { useTranslation } from "react-i18next"
import { getLocale } from "../../utils/getLocale"
import { DEFAULT_LANGUAGE, LANGUAGES } from "../../utils/constants"
import { useMemo } from "react"

const SelectLang = ({ className }: { className?: string }) => {
  const currentLang = getLocale()
  const { i18n } = useTranslation("translation", { keyPrefix: `interface` })

  const onChange = (lang: { value: string; label: string; leftIcon?: string }) => {
    void i18n.changeLanguage(lang.value)
  }

  const langList = useMemo(() => {
    if (!LANGUAGES?.length) return []
    return [
      { value: "ru", label: "Русский", leftIcon: "/img/lang/ru.png" },
      { value: "en", label: "English", leftIcon: "/img/lang/en.png" },
    ].filter((lang) => LANGUAGES.includes(lang.value))
  }, [LANGUAGES])

  return (
    <SimpleSelect
      className={className}
      value={currentLang ?? DEFAULT_LANGUAGE}
      type={"lang"}
      list={langList}
      onChange={onChange}
    />
  )
}

export default SelectLang
